import React, { useState } from 'react';
import { Drawer, Typography } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import EnjoLogo from '../icons/enjologo.svg';
import ShowcaseSidebar from './showcase-sidebar';

const { Text } = Typography;

const TopNavBar = () => {
  const [openSidebar, setSidebar] = useState(false);

  return (
    <div
      style={{
        width: '100%',
        height: '7vh',
        backgroundColor: 'white',
        position: 'fixed ',
        top: 0,
        zIndex: 100,
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '12px',
          padding: '16px',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <MenuOutlined
            onClick={() => setSidebar(true)}
            style={{ fontSize: '20px' }}
          />
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => (window.location.href = 'https://enjo.ai')}
          >
            <img src={EnjoLogo} alt="Enjo Logo" width={'60px'} />
          </div>
        </div>
        <>
          <Text
            strong
            onClick={() => (window.location.href = 'https://enjo.ai')}
          >
            {' '}
            Signup for free
          </Text>
        </>
      </div>
      <Drawer
        placement={'left'}
        width={250}
        open={openSidebar}
        onClose={() => setSidebar(false)}
        closeIcon={false}
        styles={{
          body: {
            padding: '0px',
            height: '100%',
            margin: '0px',
            width: '100%',
          },
        }}
      >
        <ShowcaseSidebar updateSidebar={(e) => setSidebar(e)} />
      </Drawer>
    </div>
  );
};

export default TopNavBar;
